import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import PageHero from "@/components/PageHero";

export default function WhatWeBelieve() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/doctrines").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <>
      <PageHero
        eyebrow="What we believe"
        title="Our Statement of Faith"
        subtitle="These convictions are historic, orthodox Christianity — held by faithful churches across denominations and centuries. We test everything by Scripture."
      />
      <section className="py-16 sm:py-24">
        <div className="container-editorial grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="sticky top-28">
              <span className="eyebrow">Core doctrines</span>
              <h2 className="heading-3 mt-3">Nine essential convictions.</h2>
              <p className="body-copy mt-4 text-ink-muted">
                These are the core doctrines we believe are essential to the Christian faith. On matters where
                orthodox Christians differ (baptism, church government, end-times timing), we label those as
                secondary and welcome honest study.
              </p>
              <div className="mt-6 space-y-1">
                {items.map((d) => (
                  <a key={d.slug} href={`#${d.slug}`} className="block text-sm text-ink-muted hover:text-forest">
                    · {d.title}
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="md:col-span-8 space-y-10">
            {items.map((d) => (
              <article key={d.slug} id={d.slug} className="border-b border-border pb-10 last:border-0">
                <span className="eyebrow text-forest">Doctrine 0{d.ordering}</span>
                <h2 className="heading-2 mt-2">
                  <Link to={`/what-we-believe/${d.slug}`} className="hover:text-forest">
                    {d.title}
                  </Link>
                </h2>
                <p className="lead mt-4">{d.summary}</p>
                <p className="body-copy mt-4 text-ink-muted">{d.body}</p>
                {d.key_scriptures?.length > 0 && (
                  <p className="mt-4 eyebrow">Key Scriptures · {d.key_scriptures.join(" · ")}</p>
                )}
                <div className="mt-4">
                  <Link to={`/what-we-believe/${d.slug}`} className="text-sm uppercase tracking-widest text-forest hover:underline">
                    Read fully →
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
